// @ts-nocheck
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Table, {TableProps} from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TablePagination from "@material-ui/core/TablePagination";
import PaginationActions from "../paginationactions/PaginationActions";
import _ from 'lodash';
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import ToolBar from "../toolbar/ToolBar";
import {buttonTableCell, containedButton, textButton} from "../../../utils/styles";
import Highlight from "../highlight/Highlight";
import ColumnFilterSelect from "./ColumnFilterSelect";
import ColumnFilterTextField from "./ColumnFilterTextField";
import {Checkbox, Radio} from "@material-ui/core";
import Message from "../message/Message";
import {ArrowDownward, ArrowUpward} from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
    root: {},
    toolbar: {
        paddingLeft: 0,
        paddingRight: 0,
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-end'
        }
    },
    spacer: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'inline-block'
        }
    },
    caption: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'inline-block'
        }
    },
    selectRoot: {
        marginLeft: 0,
        marginRight: 0,
        [theme.breakpoints.down('sm')]: {
            marginLeft: theme.spacing(),
            marginRight: theme.spacing(4)
        }
    },
    ...containedButton(theme, false, false),
    ...textButton(theme),
    ...buttonTableCell(theme),
    addButton: {
        marginRight: theme.spacing()
    },
    sortableCell: {
        userSelect: "none",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04);"
        },
        "&:hover #iconInactive": {
            display: "flex",
        },
    },
    sortableCol: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
    },
    sortableColText: {
        overflow: "hidden",
        fontWeight: 500,
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
    },
    sortableColIcon: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: '20px',
        height: '20px'
    },
    sortIconActive: {
        fontSize: "16px",
        color: "black"
    },
    sortIconInactive: {
        display: 'none',
        fontSize: "16px",
        color: "gray"
    },
    footerTableRow: {
        backgroundColor: theme.palette.grey[100]
    }
}));

/*interface IRow {
    [key: string]: boolean | number | string;
}*/

interface ILabelValue {
    label: string;
    value: string;
}

interface IColumn<T> {
    label: string;
    field: string;
    className?: string;
    filterable?: boolean;
    filterOptions?: ILabelValue[];
    valueGetter?: (value: any | string, row?: T) => JSX.Element | string;
    customFilter?: (filterTerm: string | boolean | number, value: any, row?: T) => boolean;
    rendered?: boolean | ((value: any) => boolean);
    sortable?: false;
    ordered?: boolean;
    sortAscending?: boolean;
    customSort?: (a: T, b: T) => number;
    colspan?: number;
}

interface IFooterColumn<T> {
    className?: string;
    valueGetter: (rows: T[]) => JSX.Element | string;
    rendered?: boolean | ((value: any) => boolean);
    colspan?: number;
}

type TSelectMode = 'single' | 'multiple';

type TColumnFilterValue = string | boolean | number;

interface IColumnToFilter<T> {
    value: TColumnFilterValue;
    column: IColumn<T>;
}

export interface IDataTableProps<T> extends TableProps {
    /** Fileiras são um tipo genérico, desconhecido. */
    rows: T[];
    columns: IColumn<T>[];
    footer?: IFooterColumn<T>[];
    comparatorKeys?: string[];
    filter?: boolean;
    filterOptions?: {
        filterByColumn: boolean;
        onFilter: (value: TColumnFilterValue) => void;
    };
    sort?: boolean;
    paginate?: boolean;
    paginateOptions?: {
        resetPageOnRowsChange: boolean;
        startPage: number;
        onChangePage: (page: number) => void;
        rowsPerPage: number;
        onChangeRowsPerPage: (rowsPerPage: number) => void;
    };
    lazyLoad?: boolean;
    lazyLoadOptions?: {
        /** Parâmetro único necessário para resetar a paginação caso a fonte de dados mude. */
        fetchId: string;
        total: number;
        onFetch: (filterValues: string, sortValue: string, ascending: boolean, page: number, rowsPerPage: number) => void;
    };
    select?: boolean;
    selectOptions?: {
        mode: TSelectMode;
        selectedRows: T[];
        onSelect: (selectedRow: T | null, allSelectedRows: T[] | null) => void;
    };
    toolbarContent?: JSX.Element;
    tableContainerProps?: {
        component?: JSX.Element;
        classes?: any;
    };
    hover?: boolean;
    noRecordsText?: string;
}

export default function DataTable<T>(props: IDataTableProps<T>): JSX.Element {
    const {
        rows,
        columns,
        footer,
        comparatorKeys = [],
        filter = false,
        filterOptions = {
            filterByColumn: false,
            onFilter: value => {
            }
        },
        sort = false,
        paginate = false,
        paginateOptions = {
            resetPageOnRowsChange: true,
            startPage: 0,
            onChangePage: page => {
            },
            rowsPerPage: 5,
            onChangeRowsPerPage: rowsPerPage => {
            }
        },
        lazyLoad = false,
        lazyLoadOptions = {
            fetchId: '',
            total: 0,
            onFetch: () => {
            }
        },
        select = false,
        selectOptions = {
            mode: 'multiple',
            selectedRows: [],
            onSelect: (selectedRow, allSelectedRows) => {}
        },
        toolbarContent,
        tableContainerProps = {
            component: Paper
        },
        hover = true,
        noRecordsText = 'Nenhum registro encontrado.',
        ...rest
    } = props;
    const classes = useStyles();
    const [error, setError] = useState<string>('');
    const [page, setPage] = useState<number>(paginateOptions.startPage);
    const [rowsPerPage, setRowsPerPage] = useState<number>(paginateOptions.rowsPerPage);
    const [filterValue, setFilterValue] = useState<string>('');
    const [filterMapValue, setFilterMapValue] = useState<Map<string, string>>(new Map<string, string>());
    const [sortValue, setSortValue] = useState<string>('');
    const [ascending, setAscending] = useState<boolean>(false);
    const [filteredRows, setFilteredRows] = useState<T[]>(rows);
    const [selectedRows, setSelectedRows] = useState<T[]>([]);
    const [selected, setSelected] = useState<T>();
    const columnsToFilter = useRef<IColumnToFilter<T>[]>([]);

    useEffect(() => {
        if (select) {
            if (!comparatorKeys || comparatorKeys.length === 0) {
                setError('É necessário informar a propriedade "comparatorKeys"');
            }
        }
    }, []);

    useEffect(() => {
        if (lazyLoad !== false) {
            setFilteredRows(rows);
        } else {
            // Seta as fileiras da tabela e mantém a filtragem.
            if (!filterOptions.filterByColumn) {
                _filterWithNoLazyLoad(filterValue);
            } else {
                _filterByColumnWithNoLazyLoad();
            }

            // Seta as fileiras da tabela e mantém a ordenação.
            _sortByColumnWithNoLazyLoad();
        }

        paginate && paginateOptions.resetPageOnRowsChange && lazyLoad === false && setPage(0);
    }, [JSON.stringify(rows)]);

    useEffect(() => {
        setPage(paginateOptions.startPage);
    }, [paginateOptions.startPage]);

    useEffect(() => {
        setPage(0);
        setFilterValue('');
        setFilterMapValue(new Map<string, string>());
        setSortValue('');
        setAscending(false);
    }, [lazyLoadOptions.fetchId]);

    useEffect(() => {
        if (selectOptions.mode === 'multiple') {
            setSelectedRows(selectOptions.selectedRows);
        } else {
            setSelected(selectOptions.selectedRows[0]);
        }
    }, [selectOptions.selectedRows.length]);

    const onChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        setPage(page);

        paginate !== false && paginateOptions.onChangePage(page);

        lazyLoad !== false && lazyLoadOptions.onFetch(
            filterOptions.filterByColumn ? _transformMapInJson(filterMapValue) : filterValue,
            sortValue, ascending, page, rowsPerPage);
    };

    const onChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));

        setPage(0);

        paginate !== false && paginateOptions.onChangeRowsPerPage(parseInt(event.target.value, 10));

        lazyLoad !== false && lazyLoadOptions.onFetch(
            filterOptions.filterByColumn ? _transformMapInJson(filterMapValue) : filterValue,
            sortValue, ascending, 0, parseInt(event.target.value));
    };

    const onFilter = (value: string) => {
        if (lazyLoad !== false) {
            lazyLoadOptions.onFetch(value, sortValue, ascending, 0, rowsPerPage);
        } else {
            _filterWithNoLazyLoad(value);
        }

        setFilterValue(value);

        setPage(0);

        filterOptions.onFilter && filterOptions.onFilter(value);

        paginate !== false && paginateOptions.onChangePage(0);
    };

    const _filterWithNoLazyLoad = (value: string) => {
        if (!_.isEmpty(value)) {
            setFilteredRows(rows.filter(row => columns.some(column => {
                const columnValue = column.valueGetter
                    ? column.valueGetter(_.get(row, column.field), row)
                    : _.get(row, column.field);

                if (column.filterable !== false) {
                    if (column.customFilter && _.isFunction(column.customFilter)) {
                        // Comparação por um filtro customizado
                        return column.customFilter(value, _.get(row, column.field), row);
                    } else {
                        // Comparação por "String.prototype.includes()"
                        return (_.has(row, column.field) && columnValue.toString().toUpperCase().includes(value.toUpperCase())
                            || (column.valueGetter && _.isString(columnValue) && columnValue.toString().toUpperCase().includes(value.toUpperCase())));
                    }
                }

                return false;
            })));
        } else {
            setFilteredRows(rows);
        }
    };

    const onFilterByColumn = (columnIndex: number, column: IColumn<T>) => (value: TColumnFilterValue) => {
        // Adiciona, remove ou atualiza as colunas/valores para filtragem.
        if (!columnsToFilter.current[columnIndex] // Adiciona
            && (value || !_.isEmpty(value) || typeof value === 'boolean' || typeof value === 'number')) {
            columnsToFilter.current[columnIndex] = {
                value,
                column
            };
        } else if (columnsToFilter.current[columnIndex] // Atualiza
            && (value || !_.isEmpty(value) || typeof value === 'boolean' || typeof value === 'number')) {
            columnsToFilter.current[columnIndex].value = value;
        } else { // Remove
            delete columnsToFilter.current[columnIndex];
        }

        // Realiza a filtragem.
        if (lazyLoad !== false) {
            _filterWithLazyLoad(column.field, value.toString());
        } else {
            _filterByColumnWithNoLazyLoad();
        }

        setPage(0);

        filterOptions.onFilter && filterOptions.onFilter(value);

        paginate !== false && paginateOptions.onChangePage(0);
    };

    const _transformMapInJson = (map: Map<string, string>) => {
        return JSON.stringify(Object.fromEntries(map.entries()));
    }

    const _filterWithLazyLoad = (columnField: string, filterValue: string) => {
        //Copia os valores do mapa para utilizar neste contexto.
        let filterMapValueTmp = _.cloneDeep(filterMapValue);

        if (filterMapValueTmp.has(columnField) && filterValue.length === 0) {
            filterMapValueTmp.delete(columnField);
        }

        if (filterValue.length > 0) {
            filterMapValueTmp.set(columnField, filterValue);
        }

        //Atualiza o estado do mapa real.
        setFilterMapValue(filterMapValueTmp);

        lazyLoadOptions.onFetch(_transformMapInJson(filterMapValueTmp), sortValue, ascending, 0, rowsPerPage);
    }

    const _filterByColumnWithNoLazyLoad = () => {
        setFilteredRows(Object.values(columnsToFilter.current).reduce((accumulator, columnToFilter) => {
            return _filterByColumn(accumulator, columnToFilter.column, columnToFilter.value);
        }, rows));
    };

    const _filterByColumn = (rows: T[], column: IColumn<T>, value: TColumnFilterValue) => {
        return rows.filter(row => {
            const columnValue = column.valueGetter
                ? column.valueGetter(_.get(row, column.field), row)
                : _.get(row, column.field);

            if (column.filterable !== false) {
                if (column.customFilter && _.isFunction(column.customFilter)) {
                    // Comparação por um filtro customizado
                    return column.customFilter(value, _.get(row, column.field), row);
                } else {
                    // Comparação por "String.prototype.includes()"
                    return (_.has(row, column.field) && columnValue.toString().toUpperCase().includes(value.toString().toUpperCase())
                        || (column.valueGetter && _.isString(columnValue) && columnValue.toString().toUpperCase().includes(value.toString().toUpperCase())));
                }
            }

            return false;
        });
    };

    const onToggleAllRows = () => {
        let newSelectedRows: T[];

        if (selectedRows.length) {
            newSelectedRows = [];
        } else {
            newSelectedRows = filteredRows;
        }

        setSelectedRows(newSelectedRows);

        selectOptions.onSelect(null, newSelectedRows);
    };

    const onToggleRow = (row: T) => (event: React.ChangeEvent<HTMLInputElement>) => {
        let newSelectedRows;

        // Adiciona
        if (event.target.checked) {
            newSelectedRows = [...selectedRows, row];

            selectOptions.onSelect(row, newSelectedRows);
            // Remove
        } else {
            newSelectedRows = selectedRows.filter(rowTemp => getComparatorValue(rowTemp) !== getComparatorValue(row));

            selectOptions.onSelect(null, newSelectedRows);
        }

        setSelectedRows(newSelectedRows);
    };

    const onSelectRow = (row: T) => () => {
        setSelected(row);

        selectOptions.onSelect(row, null);
    }

    const getComparatorValue = useCallback(row => {
        return comparatorKeys.reduce((accumulator, key) => accumulator + row[key], '');
    }, [comparatorKeys, comparatorKeys.length]);

    const getColumnsLength = useCallback(() => {
        let accumulator = 0;

        select && accumulator++;

        accumulator += columns.length > 0 ? columns.filter(column => column.rendered !== false).length : 1;

        return accumulator;
    }, [columns, select]);

    const sortTableByColumn = (column: IColumn<any>) => {
        setSortValue(column.field);

        columns.map(c => {
            if (column.label == c.label) {
                c.ordered = true;
                c.sortAscending = !c.sortAscending;
            } else {
                c.ordered = false;
                c.sortAscending = false;
            }
        });

        let sortedFilteredRows: T[];

        if (!column.customSort) {
            sortedFilteredRows = [...filteredRows].sort((a: any, b: any) => {
                type type = keyof typeof a;
                let key = column.field as type;

                const valueA = _.get(a, key);
                const valueB = _.get(b, key);

                let sortResult;

                if (!valueA) {
                    sortResult = 1;
                } else if (!valueB) {
                    sortResult = -1;
                } else {
                    sortResult = valueA < valueB ? -1 : (valueA > valueB) ? 1 : 0;
                }

                return column.sortAscending || sortResult === 0 ? sortResult : (sortResult * -1);
            });
        } else {
            sortedFilteredRows = [...filteredRows].sort((rowA, rowB) => {
                const sortResult = !!column.customSort ? column.customSort(rowA, rowB) : 0;

                return column.sortAscending || sortResult === 0 ? sortResult : (sortResult * -1);
            });
        }

        setFilteredRows(sortedFilteredRows);
    }

    const _sortByColumnWithNoLazyLoad = () => {
        const orderedColumn = columns.find(tempColumn => tempColumn.ordered);

        if (!!orderedColumn) {
            sortTableByColumn(orderedColumn);
        }
    };

    const getTableRow = useCallback((row, rowIndex) => {
        const comparatorValue = getComparatorValue(row);

        return (
            <TableRow
                key={!!comparatorValue ? 'rowKey' + comparatorValue : 'rowKey' + rowIndex}
                hover={hover}>
                {select && (
                    <TableCell padding="checkbox">
                        {selectOptions.mode === 'multiple' ? (
                            <Checkbox
                                checked={selectedRows.some(rowTemp => getComparatorValue(rowTemp) === comparatorValue)}
                                onChange={onToggleRow(row)}
                                color='primary'/>
                        ) : (
                            <Radio
                                checked={!!selected && getComparatorValue(selected) === comparatorValue}
                                onChange={onSelectRow(row)}
                                value={!!comparatorValue ? comparatorValue : 'tempRadioValue' + rowIndex}
                                name='singleRadioGroup'
                                color='primary'/>
                        )}
                    </TableCell>
                )}
                {columns.map((column, columnIndex) => {
                    const value = column.valueGetter
                        ? column.valueGetter(_.get(row, column.field), row)
                        : _.get(row, column.field);

                    return column.rendered !== false && (
                        <TableCell key={'columnKey' + comparatorValue + columnIndex} className={column.className}>
                            {column.filterable !== false && !React.isValidElement(value) && !column.customFilter ? (
                                <Highlight highlight={filterValue}>{value + ''}</Highlight>
                            ) : (
                                value
                            )}
                        </TableCell>
                    );
                })}
            </TableRow>
        );
    }, [columns, filterValue, selectedRows.length, selected]);

    return (
        <>
            {((filter && !filterOptions.filterByColumn) || toolbarContent) && (
                <ToolBar
                    search={filter && !filterOptions.filterByColumn}
                    onSearch={onFilter}>
                    {toolbarContent}
                </ToolBar>
            )}
            <TableContainer {...tableContainerProps}>
                <Table {...rest}>
                    <TableHead>
                        <TableRow>
                            {select && selectOptions.mode === 'multiple' && (
                                <TableCell padding='checkbox'>
                                    <Checkbox
                                        indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                                        checked={!error && selectedRows.length > 0 && selectedRows.length === rows.length}
                                        onChange={onToggleAllRows}
                                        inputProps={{'aria-label': 'Selecionar todos'}}
                                        disabled={!!error}
                                        color='primary'/>
                                </TableCell>
                            )}
                            {select && selectOptions.mode === 'single' && (
                                <TableCell padding="checkbox"/>
                            )}
                            {columns.map((column, columnIndex) => column.rendered !== false && (
                                <TableCell
                                    key={column.label + columnIndex}
                                    className={sort && column.sortable ? classes.sortableCell : ''}
                                    onClick={sort && column.sortable ? () => sortTableByColumn(column) : () => {}}>
                                    {sort && column.sortable ?
                                        <div className={classes.sortableCol}>
                                            <div className={classes.sortableColText}>
                                                {column.label}
                                            </div>
                                            <div className={classes.sortableColIcon}>
                                                {column.ordered ?
                                                    <>
                                                        {column.sortAscending
                                                            ? <ArrowUpward fontSize='small' className={classes.sortIconActive}/>
                                                            : <ArrowDownward fontSize='small' className={classes.sortIconActive}/>}
                                                    </> :
                                                    <ArrowDownward id='iconInactive' fontSize='small' className={classes.sortIconInactive}/>
                                                }
                                            </div>
                                        </div> :
                                        <>
                                            {column.label}
                                        </>
                                    }
                                    {filterOptions.filterByColumn && column.filterable && (
                                        <>
                                            {column.filterOptions ? (
                                                <ColumnFilterSelect
                                                    id={`select${columnIndex}`}
                                                    filterOptions={column.filterOptions}
                                                    onChange={onFilterByColumn(columnIndex, column)}/>
                                            ) : (
                                                <ColumnFilterTextField
                                                    id={`textField${columnIndex}`}
                                                    onChange={onFilterByColumn(columnIndex, column)}/>
                                            )}
                                        </>
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!error && (paginate !== false && lazyLoad === false
                            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(getTableRow)
                            : filteredRows.map(getTableRow))}
                        {!error && !filteredRows.length && (
                            <TableRow>
                                <TableCell colSpan={getColumnsLength()}>{noRecordsText}</TableCell>
                            </TableRow>
                        )}
                        {!!error && (
                            <TableRow>
                                <TableCell colSpan={getColumnsLength()}>
                                    <Message type='error'>{error}</Message>
                                </TableCell>
                            </TableRow>
                        )}
                        {!!rows.length && !!footer && (
                            <TableRow className={classes.footerTableRow}>
                                {footer.map((column, columnIndex) => column.rendered !== false && (
                                    <TableCell
                                        key={columnIndex}
                                        colSpan={column.colspan || 1}
                                        className={column.className}>
                                        {column.valueGetter(rows)}
                                    </TableCell>
                                ))}
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                {(paginate !== false || lazyLoad !== false) && filteredRows.length > 0 && (
                    <TablePagination
                        classes={{
                            toolbar: classes.toolbar,
                            selectRoot: classes.selectRoot,
                            spacer: classes.spacer,
                            caption: classes.caption
                        }}
                        component='div'
                        labelDisplayedRows={({from, to, count}) => `${from} até ${to} de ${count} registro(s)`}
                        labelRowsPerPage=''
                        rowsPerPageOptions={[5, 10, 25]}
                        count={lazyLoad !== false ? lazyLoadOptions.total : filteredRows.length}
                        rowsPerPage={Number(rowsPerPage)}
                        page={page}
                        onPageChange={onChangePage}
                        onRowsPerPageChange={onChangeRowsPerPage}
                        ActionsComponent={PaginationActions}/>
                )}
            </TableContainer>
        </>
    );
}
